import { __assign, __rest } from "tslib";
import React from 'react';
import VeltCommentsSidebarLocationFilterDropdownTriggerLabel from './VeltCommentsSidebarLocationFilterDropdownTriggerLabel/VeltCommentsSidebarLocationFilterDropdownTriggerLabel';
import { transformWireframeProps } from '../../../../utils/propUtils';
var VeltCommentsSidebarLocationFilterDropdownTrigger = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comments-sidebar-location-filter-dropdown-trigger-wireframe", __assign({}, transformedProps), children));
};
VeltCommentsSidebarLocationFilterDropdownTrigger.Label = VeltCommentsSidebarLocationFilterDropdownTriggerLabel;
export default VeltCommentsSidebarLocationFilterDropdownTrigger;
